var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6500_3700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23092 15.89C8.23092 17.3345 8.22269 18.7791 8.23603 20.2236C8.23603 20.6363 8.16119 20.6951 7.79307 20.4795C5.31978 19.0274 2.83934 17.5873 0.351703 16.1593C0.238206 16.1057 0.14369 16.0185 0.0808314 15.9093C0.0179728 15.8002 -0.0102456 15.6743 -2.95964e-05 15.5485C0.0102245 12.6595 0.0102245 9.77287 -2.95964e-05 6.88866C-2.95964e-05 6.49348 0.0881715 6.445 0.426556 6.6431C2.91625 8.1 5.4114 9.54796 7.91203 10.987C8.18069 11.1407 8.23602 11.3357 8.23397 11.6153C8.22577 13.0371 8.23092 14.4631 8.23092 15.89Z",
    fill: "#A0A7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9918 11.2295C17.9918 12.6379 17.9816 14.0473 17.999 15.4599C18.0041 15.8097 17.9037 16.016 17.5889 16.1956C15.1279 17.606 12.6843 19.035 10.2326 20.4569C9.77112 20.7251 9.76396 20.721 9.76396 20.1597C9.76396 17.3254 9.77008 14.49 9.7547 11.6546C9.7547 11.2935 9.87877 11.1057 10.1823 10.9324C12.6094 9.53739 15.0274 8.12485 17.4484 6.71955C17.9867 6.41001 17.9888 6.41001 17.9888 7.05901C17.9922 8.44918 17.9932 9.83935 17.9918 11.2295Z",
    fill: "#A0A7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.783447 5.06559C2.23645 4.22158 3.59102 3.43639 4.94456 2.64913C6.16992 1.93823 7.39834 1.23351 8.6155 0.50816C8.87697 0.352359 9.07079 0.320376 9.35176 0.485463C11.8244 1.93961 14.3031 3.38101 16.788 4.80971C17.1161 4.99852 17.193 5.09137 16.8034 5.31527C14.3024 6.75153 11.8117 8.20431 9.31791 9.65604C9.15487 9.75097 9.01029 9.85104 8.80521 9.72826C6.16581 8.18882 3.52436 6.65662 0.783447 5.06559Z",
    fill: "#A0A7AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6500_3700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20.25,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModels);
export default __webpack_public_path__ + "static/media/models.0ea0031e1cbf7d6bf7dada21764e822a.svg";
export { ForwardRef as ReactComponent };